import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import A from '../../../common/A';
import BackButton from '../../../navigate/BackButton';
import { pwInquiryAPI } from '../../../../api/accountAPI';
import { emailRegExp } from '../../../../utils/utilityEtc';
import { MESSAGE, TYPE, URL } from '../../../../constant';
import { useAlert, useInput, useLoading, useUserInfo } from '../../../../hooks';

function PwInquiry() {
  const history = useHistory();
  const [Alert, CodeAlert] = useAlert();
  const [emailCheck, setEmailCheck] = useState('');
  const [email, onChangeEmail, onEmailReset] = useInput('');
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const { setLoading, clearLoading } = useLoading();

  const onBlur = useCallback((e) => {
    if (!email) return;
    // 이메일 양식이 맞으면  true 아니면 false;
    const result = emailRegExp(email);
    setEmailCheck(result ? 'success' : 'fail');

  }, [email]);

  const onSubmit = useCallback(async () => {
    
    if (!email || emailCheck === 'fail') return;
    setLoading();
    const resp = await pwInquiryAPI({
      emailAdrs: email,
      chnCd: info?.channelCode ? info?.channelCode : '',
    });
    clearLoading();
    if (resp?.code === 'S000000') {
      history.push({
        pathname: URL.ACCOUNT.PW_INQUIRY_SUCCESS,
        state: {
          email,
        }
      })
    } else {
      if (!resp) {
        Alert(MESSAGE.UNKNOWN_ERROR.msg, null, "msg001");
      } else {
        console.log(resp.error);
        CodeAlert(resp?.error);
      }
    }
  }, [email, emailCheck]);

  return (
    <React.Fragment>
      <div className={clsx(
        "header_top",
        info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'gb' : ''
      )}>
        <div className="inner">
          {
            info.channelCode === TYPE.CHANNEL.GLOBAL01
              ? (
                <div className="btns_wrap cls">
                  <div className="app_btn">
                    <button className="btn_exit" type="button" onClick={() => history.goBack()}>
                      <img src="./static/images/icon/btn_back.svg" alt="" />
                    </button>
                  </div>
                  <div className="tit_gm center_tit24">{t("MY_01_01.msg001")}</div>
                </div>
              )
              : (
                <div className="btns_wrap header-trans">
                  <div className="login cls">
                    <BackButton />
                    <A onClick={() => history.push(URL.ACCOUNT.LOGIN)}>{t("MY_01_01.msg001")}</A>
                  </div>
                </div>
              )
          }
        </div>
      </div>
      <div className={clsx(
        "layout-def log_in pw with_bottom_area",
        info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'gb' : ''
      )}>
        <div className="container">
          <div className="inner">
            <div className="center_wrap">
              <div className="logo_wrap">
                <div className="logo">
                  <img src="./static/images/common/img_pw@2x.png" alt="" />
                </div>
              </div>
              <div className="noti_wrap">
                <div className="noti1" dangerouslySetInnerHTML={{__html: t("MY_01.msg002")}} />
                <div className="noti2">{t("MY_01.msg003")}</div>
              </div>
              <div className="input_wrap">
                <article>
                  <div className="input_box soft_white_box">
                    <input
                      type="email"
                      name="email"
                      placeholder={t("MY_01.msg004")}
                      value={email}
                      onChange={onChangeEmail}
                      onBlur={onBlur}
                    />
                    <div className="r_area">
                      {
                        (!_.isEmpty(email) || _.isEqual(emailCheck, 'fail')) && (
                          <button
                            type="button"
                            onClick={onEmailReset}
                          >
                            <img width="40" src="./static/images/icon/ic_error2@2x.png" alt="" />
                          </button>
                        )
                      }
                    </div>
                  </div>
                  {
                    _.isEqual(emailCheck, 'fail') && (
                      <div className="red_txt fs14">{t("MY_00.msg003")}abc@mathpid.com</div>
                    )
                  }
                </article>
              </div>
            </div>
            <div className="bottom_wrap btn_wrap static">
              <A
                style={{cursor: 'pointer'}}
                className="btn btn-white"
                onClick={onSubmit}
              >
                {t("MY_01.msg006")}
              </A>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PwInquiry;